import { BaseLayout, type NavSection } from './BaseLayout';
import {
  LayoutDashboard, Network, Globe, MapPin, Building2, Shield,
  CreditCard, Megaphone, Settings, Activity,
  Map, DollarSign, Rocket, ClipboardList, Users, Package, FileText,
  Clapperboard, GraduationCap, MessageSquarePlus, MessageSquare,
  Radio, Briefcase, Wrench, Headphones, CalendarDays, ListTodo, Palette,
  Database, GitBranch, FlaskConical, User, Bell,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';

/**
 * Sidebar do Admin Master — Visão da plataforma inteira.
 * Cor premium diferenciada do Admin Escola.
 *
 * Convenção de rotas:
 * - /master/*  → Dashboards consolidados do Master
 * - /{domínio}/* → Módulos operacionais próprios (comercial, suporte, implantacao)
 */
const MASTER_SECTIONS: NavSection[] = [
  {
    title: 'Operacional Master',
    items: [
      { to: '/master/dashboard', label: 'Operacional', icon: LayoutDashboard },
      { to: '/master/comunicados', label: 'Comunicados', icon: Megaphone },
      {
        to: '#',
        label: 'Inteligência',
        icon: Activity,
        subItems: [
          { to: '/master/noc', label: 'NOC' },
          { to: '/master/mapa', label: 'Mapa de Cobertura' },
          { to: '/master/indices', label: 'Índice Segurança' },
          { to: '/master/financeiro', label: 'Financeiro' },
          { to: '/master/crescimento', label: 'Crescimento' },
        ],
      },
      { to: '/master/ead', label: 'Video Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Gestão',
    items: [
      { to: '/master/redes', label: 'Redes', icon: Network },
      { to: '/master/estados', label: 'Estados', icon: Globe },
      { to: '/master/municipios', label: 'Municípios', icon: MapPin },
      { to: '/master/escolas', label: 'Escolas', icon: Building2 },
      { to: '/master/usuarios', label: 'Usuários', icon: Users },
    ],
  },
  {
    title: 'Sistema',
    items: [
      { to: '/master/ecad-studio', label: 'Cadastrar Videos', icon: Clapperboard },
      { to: '/master/configuracoes', label: 'Configurações', icon: Settings },
      { to: '/master/backups', label: 'Gestão de Backups', icon: Database },
      { to: '/master/versao-codigo', label: 'Versão Código', icon: GitBranch },
      { to: '/master/saude-operacional', label: 'Saúde Operacional', icon: Activity },
      { to: '/master/login-acessos', label: 'Login e Acessos', icon: Shield },
      {
        to: '#',
        label: 'Serviços',
        icon: Wrench,
        subItems: [
          { to: '/master/rfid', label: 'Dashboard RFID' },
          { to: '/master/dispositivos', label: 'Dispositivos' },
          { to: '/master/credenciais', label: 'Credenciais' },
        ],
      },
      {
        to: '#',
        label: 'Outros',
        icon: Package,
        subItems: [
          { to: '/simulador', label: 'Simulador' },
          { to: '/master/laboratorio-testes', label: 'Lab Testes IA' },
          { to: '/master/feedback', label: 'Feedback' },
          { to: '/suporte/chamados', label: 'Suportes' },
          { to: '/master/customizacao', label: 'Customização Visual' },
          { to: '/master/logs', label: 'Logs e Erros' },
          { to: '/comercial/oportunidades', label: 'Oportunidades' },
          { to: '/comercial/contratos', label: 'Contratos' },
          { to: '/implantacao', label: 'Implantações' },
          { to: '/implantacao/visitas', label: 'Visitas' },
          { to: '/implantacao/treinamentos', label: 'Treinamentos' },
          { to: '/agenda', label: 'Agenda' },
          { to: '/tarefas', label: 'Tarefas' },
          { to: '/master/billing', label: 'Billing' },
          { to: '/master/planos', label: 'Planos' },
          { to: '/master/assinaturas', label: 'Assinaturas' },
        ],
      },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/master/perfil', label: 'Meu Perfil', icon: User },
      { to: '/master/alertas', label: 'Meus Comunicados', icon: Megaphone },
    ],
  },
];

export function MasterLayout() {
  const isTestEnv = typeof window !== 'undefined' && window.location.hostname === 'test.alunoconectado.com.br';
  const { brandColor, brandGradient } = useProfileBrandColor('MASTER');

  const sections = MASTER_SECTIONS.map(sec => {
    return {
      ...sec,
      items: sec.items.filter(item => {
        if (item.label === 'Cadastrar Videos' && isTestEnv) {
          return false;
        }
        return true;
      })
    };
  });

  return (
    <BaseLayout
      sections={sections}
      headerTitle="Aluno Conectado"
      brandSubtitle="Comando Master"
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}
